import { render } from "./CResultGameLto.vue?vue&type=template&id=75f29997"
const script = {}

import "./CResultGameLto.vue?vue&type=style&index=0&id=75f29997&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__